var _defs, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f04c3e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.52,2.52s-.92,0,0,0l-36.77,29.42c-2.76,3.36-2.76,7.56,0,10.09,2.76,2.52,7.35,4.2,10.11.84l23.9-19.33v73.96c0,4.2,2.76,6.72,7.35,6.72s7.35-2.52,7.35-6.72V22.69l23.9,20.17c2.76,2.52,7.35,2.52,10.11,0,1.84-1.68,1.84-2.52,1.84-4.2s-1.84-4.2-2.76-5.04L124.2,0l-3.68,2.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.48,247.55s.92,0,0,0l36.77-28.6c2.76-3.27,2.76-7.35,0-9.81-2.76-2.45-7.35-4.09-10.11-.82l-23.9,18.8v-71.91c0-4.09-2.76-6.54-7.35-6.54s-7.35,2.45-7.35,6.54v72.73l-23.9-19.61c-2.76-2.45-7.35-2.45-10.11,0-1.84,1.63-1.84,2.45-1.84,4.09s1.84,4.09,2.76,4.9l41.36,32.69,3.68-2.45Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3.93,
    y: 119.78,
    width: 241.19,
    height: 9.33,
    rx: 4.67,
    ry: 4.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.38cc8187ee9af714bf6e1251abfcad67.svg";
export { ForwardRef as ReactComponent };